export const VALID_ALPHANUMERIC_REGEX =
  /(^[-a-zA-Z0-9]*[a-zA-Z]+[-a-zA-Z0-9]*$)/;
